<template>
  <div class="gc-form-report">
    <gc-filter-split-view
      :showLeftContainer="showLeftContainer"
      :showRightContainer="showRightContainer"
      :rightContainerWidth="250"
    >
      <template #leftContent>
        <gc-report-pdf :dataSource="dataSource"></gc-report-pdf>
      </template>
      <template #rightContent>
        <gc-filter-panel
          :toolbar="filterToolbar"
          :formItemData="formItemData"
          :formHeight="getFilterFormHeight"
          :formLocation="'form-report'"
          :setFilterValues="setFilterValues"
        >
        </gc-filter-panel>
      </template>
    </gc-filter-split-view>
  </div>
</template>

<script>
import ApiService from "../_services/api/api.service";

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export default {
  mixins: [],
  props: {
    /**
     * data grid data source configuratio
     */
    reportConfig: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  components: {},
  data() {
    //
    return {
      showLeftContainer: true,
      showRightContainer: true,
      filterToolbar: {
        filterOnEnter: true,
        close: {
          visible: false,
        },
      },
      filterModel: [],
      dataSource: undefined,
      parameterList: [],
    };
  },
  mounted() {},
  computed: {
    formItemData() {
      return this.reportConfig.Parameters.filter((x) => x != null);
    },
    getFilterFormHeight() {
      // Fixed Hight Values
      // 65 : Main Layout Header Toolbar Height
      // 100 : Split View (right side) toolbar height + Apply & Clear btn height with padding & margin
      return window.innerHeight - 65 - 100;
    },
  },
  created() {},

  methods: {
    setFilterValues(dataField, value) {
      if (dataField == "apply") {
        this.setLoading(true);
        this.setParameters();
        this.ExportToPdf();
      } else if (dataField == "clear") {
        this.dataSource = undefined;
        this.filterModel = [];
      } else {
        if (Array.isArray(value)) {
          this.filterModel[dataField] = [];
          value.forEach((element) => {
            if (Array.isArray(element)) {
              this.filterModel[dataField].push(element[2]);
            }
          });
        } else {
          this.filterModel[dataField] = value;
        }
      }
    },
    setParameters() {
      this.parameterList = [];
      for (const property in this.filterModel) {
        let value = undefined;
        if (property.toString().toLowerCase().includes("date"))
          value = this.filterModel[property]
            ? this.filterModel[property].toFilterDateStringFormattedReport()
            : null;
        else value = this.filterModel[property];
        if (value && typeof this.filterModel[property] != "function")
          this.parameterList.push({ prop: property, value: value });
      }
    },
    getQueryString() {
      let link = `/api/GetReportPdf?reportLocation=${this.reportConfig.Location}`;
      this.parameterList.forEach((parameter) => {
        let param = parameter.value;
        link += `&${parameter.prop}=${param}`;
      });
      return link;
    },
    async ExportToPdf() {
      await ApiService.get(this.getQueryString())
        .then((res) => {
          this.setLoading(false);
          const blob = b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          this.dataSource = blobUrl;
        })
        .catch((error) => {
          this.$logger.debug("Error ", error);
          this.setLoading(false);
          //   console.log("Error ", error);
          //   this.displayServerError(error, "Print preview failed.");
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.gc-form-report,
.filter-split-container {
  height: inherit;
}
</style>
